import * as React from 'react';
import { InfoMessagePositionsEnum } from '@websky/graphql';
import { PaymentResult } from '@entities/payment';
import InfoMessages from '../../../../../InfoMessages';
const AviaPaymentResult = props => {
    const successAdditionalBanner = (React.createElement(InfoMessages, { position: InfoMessagePositionsEnum.successfulPaymentPopUp, renderMessagesWithoutWrapper: true }));
    return React.createElement(PaymentResult, Object.assign({ successAdditionalBanner: successAdditionalBanner }, props));
};
export default AviaPaymentResult;
